import type { ChangeEvent } from "react";

import { Checkbox } from "@/components/Checkbox/Checkbox";
import { AirlineAvatar } from "@/features/flights/components/AirlineAvatar";
import type { Airline } from "@/features/flights/types/types";

type Props = {
  airlines: Airline[];
  selectedAirlines: string[];
  userManuallySelectedAllAirlines: boolean;
  onSingleAirlineChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    airline: Airline,
  ) => void;
};

export const AirlinesFilter = ({
  airlines,
  selectedAirlines,
  userManuallySelectedAllAirlines,
  onSingleAirlineChange,
}: Props) => {
  const areAllAirlinesSelected = selectedAirlines?.length === airlines.length;

  return (
    <ul>
      {airlines.map((airline) => (
        <li key={airline.name}>
          <label className="my-1 flex justify-between py-2">
            <span className="flex items-center">
              <AirlineAvatar airline={airline} size="large" />
              <span className="mr-2 ml-2 font-normal">{airline.name}</span>
            </span>

            <Checkbox
              checked={
                selectedAirlines?.includes(airline.code) &&
                (airlines.length === 1 ||
                  userManuallySelectedAllAirlines ||
                  !areAllAirlinesSelected)
              }
              onChange={(e) =>
                onSingleAirlineChange(e, e.target.checked, airline)
              }
              density="compact"
            />
          </label>
        </li>
      ))}
    </ul>
  );
};
